import { useEffect, useMemo } from 'react'

import { Divider, Flex, Space } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { ToolbarMoreButton } from '../MoreButton'
import { useToolbarStore } from '../Store/hooks/useStore'

const ActionTracker = ({
  groupIndex,
  itemIndex,
  uniqueIndex
}: {
  groupIndex: number
  itemIndex: number
  uniqueIndex: number
}) => {
  const { maxActionCount, addToMoreGroups, rmFromMoreGroups } = useToolbarStore(
    state =>
      pick(state, ['maxActionCount', 'addToMoreGroups', 'rmFromMoreGroups'])
  )

  useEffect(() => {
    if (maxActionCount <= 0) {
      return
    }
    // 如果当前按钮在可展示的范围内，则不需要添加到更多分组
    if (uniqueIndex <= maxActionCount) {
      rmFromMoreGroups({ groupIndex, itemIndex })
    } else {
      addToMoreGroups({
        groupIndex,
        itemIndex
      })
    }
  }, [
    maxActionCount,
    groupIndex,
    itemIndex,
    uniqueIndex,
    addToMoreGroups,
    rmFromMoreGroups
  ])

  return null
}

export const ToolbarActionGroup = () => {
  const { moreButtonVisible, rawGroups, permanentGroup, visibleGroups } =
    useToolbarStore(state =>
      pick(state, [
        'moreButtonVisible',
        'rawGroups',
        'permanentGroup',
        'visibleGroups'
      ])
    )

  const trackerNodes = useMemo(() => {
    let uniqueIndex = -1
    return rawGroups
      .map((group, groupIndex) => {
        return group.map((item, itemIndex) => (
          <ActionTracker
            key={item.key}
            groupIndex={groupIndex}
            itemIndex={itemIndex}
            uniqueIndex={++uniqueIndex}
          />
        ))
      })
      .flat()
  }, [rawGroups])

  const visibleNodes = useMemo(() => {
    return visibleGroups
      .map(
        (group, groupIndex) =>
          !!group.length && (
            <Flex key={groupIndex} gap={8}>
              {group}
            </Flex>
          )
      )
      .filter(Boolean)
  }, [visibleGroups])

  return (
    <div>
      {trackerNodes}
      <Space separator={<Divider orientation='vertical' />}>
        {visibleNodes}
        {moreButtonVisible && <ToolbarMoreButton />}
        {permanentGroup}
      </Space>
    </div>
  )
}
